import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/wordmark.svg")